// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"afc1cb44","66":"2d39dc55","318":"a62e3a94","428":"53be5f43","783":"812fc482","932":"623aa1ef"}[chunkId] + ".chunk.css";
};